export function buildWhatsappLink({ name, category_label, size, budget_range, description }) {
  const number = process.env.REACT_APP_WA_NUMBER;
  const lines = [
    `Halo Lasercut, saya ${name}.`,
    `Saya tertarik untuk konsultasi custom kategori *${category_label}*.`,
    size ? `Ukuran perkiraan: ${size}.` : null,
    `Budget range: ${budget_range}.`,
    `Detail kebutuhan: ${description}`,
  ].filter(Boolean);
  const text = encodeURIComponent(lines.join("\n"));
  return `https://wa.me/${number}?text=${text}`;
}
